import React from 'react';
import { Link } from "react-router-dom";
import axios from "axios";
//import {Redirect} from 'react-router-dom';
import logoreg from "../abc.png"
import Path from "./config";
class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sbg_mobile_no: "",
            sbg_email_id: "",
            islogin: false,
            sbg_id: ''
        }

    }
    componentDidMount() {
        localStorage.setItem("show#doc123", "No");
        localStorage.setItem("ed@fgg", "YES");
        localStorage.setItem("uid", "23");
        localStorage.setItem("regid", "432");
        localStorage.setItem("show#doc12", "No");
        //console.log("history===========",this.props.location.search);
        // const sbg_id = this.props.match.params.sbg_id;
        let webid = new URLSearchParams(this.props.location.search);
        let webidnew = webid.get("sbg_id");
        // this.setState({
        //     sbg_id:this.props.match.params.sbg_id
        // })
        //console.log("url value",sbg_id)

        if (webidnew !== null) {
            localStorage.setItem("userId", webidnew);
            //console.log("store userid");
            this.props.history.push(`./FormProfile/Fullbiodata`);
        }
        else {
            //console.log("not userid");
        }


    }

    mobileHandler = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_mobile_no: e.target.value })
        }

    }
    passwordHandler = (e) => {
        this.setState
            ({ sbg_password: e.target.value })
    }

    submitClick = (e) => {
        e.preventDefault();
        let isValid = true;

        if (this.state.sbg_mobile_no === "") {
            alert("Username and Password are reqired feilds")
            isValid = false;
        }
        if (!this.state.sbg_password || this.state.sbg_password.length < 4) {
            alert("Password length grater than 4 digits");
            isValid = false;
            return false
        }

        if (isValid) {
            let tempStr = "sbg_mobile_no=" + this.state.sbg_mobile_no +
                "&sbg_password=" + this.state.sbg_password

            axios.post(Path + `Suchi_bride_groom_login.php?` + tempStr)
                .then(function (response) {

                    if (response.data.result === "Sucessfull") {


                        localStorage.setItem("userId", response.data.sbg_id);
                        localStorage.setItem("phoneId", this.state.sbg_mobile_no);
                        this.props.history.push(`./FormProfile`);
                    }
                    else if (response.data.result === "OTP Pending") {
                        alert("कृपया ओटीपी प्रमाणित करून आपल्या मोबाइल नंबरची पुष्टी करा.");
                        localStorage.setItem("userId", response.data.sbg_id);
                        localStorage.setItem("phoneId", this.state.sbg_mobile_no);
                        this.props.history.push(`./Otpcomfirm`);
                    }
                    else if (response.data.result === "PaymentPending") {
                        // alert("रेजिस्ट्रेशन बंद करण्यात  आले आहे. ");

                        //commented to stop new payment on 6-9-23
                        localStorage.setItem("userId", response.data.sbg_id);
                        localStorage.setItem("phoneId", this.state.sbg_mobile_no);
                        this.props.history.push(`./Payment`);


                    } else if (response.data.result === "blacklisted") {
                        //  document.getElementById("error").innerHTML = "तुमचे अकाउंट बंद करण्यात आले आहे सुरू करण्यासाठी कृपया लेवा शुभमंगल ऑफिस ला संपर्क करावा.";
                        alert("तुमचे अकाउंट बंद करण्यात आले आहे सुरू करण्यासाठी कृपया लेवा शुभमंगल ऑफिस ला संपर्क करावा.");
                    }
                    else {
                        alert("अवैध मोबाइल नंबर किंवा संकेतशब्द कृपया पुन्हा प्रविष्ट करा");
                    }

                }.bind(this))
        }

    }


    cancleClick = () => {
        this.props.history.push(`/`);
    }


    render() {




        return (
            <>
                <div className="container-fluid">
                    <span className="align-middle d-flex justify-content-center">
                        <img src={logoreg} alt="logo" style={{ width: "300px" }}></img>
                    </span>
                    <span className="align-middle d-flex justify-content-center m-5">
                        टीप :- ज्यांचे मागील वर्षी लेवा शुभमंगल पुस्तक सुची मध्ये नाव असेल आणि आता ज्यांना आयडी आठवत नसेल त्यांनी खालील नंबर वर कॉल करावे आणि पासवर्ड आठवत नसेल त्यांनी FORGET PASSWORD वर क्लिक करावे आणि पुढील प्रोसेस करावी तरीही नाही जमल्यास  आम्हाला  9730550506 किंवा 9420309965 यावर कॉल करावा.

                    </span>

                    <span className='align-middle d-flex justify-content-center m-5 text-danger' id="error"></span>
                    <div className="row justify-content-md-center my-5 ">

                        <div className="col-md-5 border  border-5 p-3 mb-2 bg-light text-dark">
                            <div className="mb-3  ">
                                <span className="d-block p-2 bg-danger text-white text-md-center text-capitalize">Login Here</span>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="formGroupExampleInput" className="form-label">मोबईल नंबर </label>
                                <input type="text" maxLength="13" className="form-control" value={this.state.sbg_mobile_no} onChange={this.mobileHandler} placeholder="Mobile Number" />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="formGroupExampleInput" className="form-label">पासवर्ड  </label>
                                <input type="password" maxLength="12" className="form-control" value={this.state.sbg_password} onChange={this.passwordHandler} placeholder="Password" />
                            </div>

                            <div>
                                <div className="mb-3 text-center " style={{ float: "left" }}>
                                    {/* <Link to="/Otpcomfirm"> */}
                                    <button type="button" className="btn btn-success m-2" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}> Login ▶️ </button>
                                    {/* </Link> */}
                                    <button type="button" className="btn btn-primary" onClick={() => this.cancleClick()}> Cancel ❎ </button>
                                </div>
                                <div className="mt-3 text-center " style={{ float: "right" }}>  <Link to={`/ForgotPassword`} className="link_class" >Forgot Password ? </Link></div>
                            </div>
                        </div>
                    </div>

                </div>



            </>
        )
    }
}

export default Login

